export function getBaseURL() {
  let base = ''

  if (window.location.hostname.indexOf('localhost') >= 0) {
    base = window.location.origin + getLocalPath()
  } else {
    base = window.location.origin
  }

  return base
}

function getLocalPath() {
  const pathname = window.location.pathname
  let path = ''

  if (pathname.indexOf('cti-advisor') >= 0) {
    path = '/site/cti-advisor'
  } else if (pathname.indexOf('cti-investor') >= 0) {
    path = '/site/cti-investor'
  } else if (pathname.indexOf('cti-blog') >= 0) {
    path = '/site/cti-blog'
  }

  return path
}

export function isLocal() {
  return window.location && window.location.hostname.indexOf('localhost') >= 0
}

export function getAdvisorPathIfLocal() {
  return isLocal() ? '/site/cti-advisor' : ''
}

export function getInvestorPathIfLocal() {
  return isLocal() ? '/site/cti-investor' : ''
}

export function getInstitutionalPathIfLocal() {
  return isLocal() ? '/site/cti-institutional' : ''
}

export function getBlogPathIfLocal() {
  return isLocal() ? '/site/blogspa' : '/insights/latest-insights'
}

export function isPreview() {
  return window.location && window.location.pathname.indexOf('/preview') >= 0
}
